import { useState } from 'react';

/**
 * copy somewhere in the internet
 * @ref https://usehooks.com/useLocalStorage/
 * @param {string} key
 * @param {*} initialValue
 */
export function useLocalStorage(key, initialValue, isSaveStoreAsInit) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      if (item) return JSON.parse(item);

      if (typeof initialValue == 'function') {
        const storeValue = initialValue();
        if (isSaveStoreAsInit) {
          window.localStorage.setItem(key, JSON.stringify(storeValue));
        }
        return storeValue;
      }

      if (isSaveStoreAsInit) {
        window.localStorage.setItem(key, JSON.stringify(initialValue));
      }
      return initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      if (typeof initialValue == 'function') return initialValue();
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };

  const clearValue = () => {
    window.localStorage.clearItem(key);
  };

  return [storedValue, setValue, clearValue];
}
